import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import MakeHash from 'make-hash';
import TransitionLink from 'components/transition-link/transition-link';
import Icon from 'components/icons/icon';
import Text from 'components/text/text';
import classNames from 'classnames';
import GridRow from 'components/grid/grid-row';
import GridCol from 'components/grid/grid-col';
import LevelMeter from 'components/level-meter/level-meter';
import messages from './messages';

function SaddleProductInfo(props) {
  const { intl, data } = props;

  const saddleSizeIndicator = function() {
    const saddleClass = classNames(
      'circle',
      'circle_textStart',
      {
        'circle_orange': data.size === 130,
        'circle_black': data.size === 168,
        'circle_blue': data.size === 143,
        'circle_green': data.size === 155,
      }
    );

    return (
      <span className={saddleClass}></span>
    );
  };

  const paddingLevels = function() {
    const saddleName = data.name;
    const levels = data.padding_levels.map((obj, i) => {
      const setClass = classNames(
        'set-bd_detached',
        {
          'mix-set-bd_borderTop': i > 0,
        }
      );
      const boxClass = classNames(
        'box',
        {
          'box-padTopMed': i > 0,
        }
      );

      return (
        <div className={setClass} key={MakeHash(`${saddleName}_${obj.padding}`)}>
          <div className={boxClass}>
            <GridRow>
              <GridCol desktop="6" mobile="2" tablet="4" tabletLg="4">
                <LevelMeter
                  current={obj.padding}
                  max={6}
                />
              </GridCol>

              <GridCol desktop="6" mobile="2" tablet="4" tabletLg="4">
                <ul className="vList">
                  {obj.saddles.map((model, i) => {
                    return (
                      <li key={MakeHash(`${model.name}_${i}`)}>
                        <TransitionLink
                          className="txt_sm mix-txt_uppercase mix-txt_colorDarkGray"
                          to={model.url}
                          target="_blank"
                        >
                          {model.name}

                          <Icon
                            iconSize="xs"
                            iconType="externalLink"
                            className="mix-icon_textEnd"
                          />
                        </TransitionLink>
                      </li>
                    );
                  })}
                </ul>
              </GridCol>
            </GridRow>
          </div>
        </div>
      );
    });

    return (
      <div>
        <GridRow>
          <GridCol desktop="6" mobile="2" tablet="4" tabletLg="4">
            <Text
              type="sm"
              color="DarkGray"
              className="mix-txt_uppercase"
              >
              {intl.formatMessage(messages.padding_level_label)}
            </Text>
          </GridCol>

          <GridCol desktop="6" mobile="2" tablet="4" tabletLg="4">
            <Text
              type="sm"
              color="DarkGray"
              className="mix-txt_uppercase"
            >
              {intl.formatMessage(messages.saddle_models_label)}
            </Text>
          </GridCol>
        </GridRow>

        {levels}
      </div>
    );
  };

  return (
    <div>
      <div className="set-bd set-bd_flush">
        <Text
          type="xl"
          color="Darkest"
          weight="light"
        >
          {data.name}
        </Text>
      </div>

      <div className="set-bd set-bd_detached">
        {saddleSizeIndicator()}

        <Text
          type="sm"
          color="DefaultGray"
          className="mix-txt_uppercase"
        >
          {intl.formatMessage(messages.saddle_size_label) + ':'}
        </Text>

        <Text
          type="sm"
          color="DarkGray"
        >
          {` ${data.size}`}
        </Text>
      </div>

      <div className="set-bd set-bd_detached">
        <Text
          type="md"
          color="DarkGray"
          dangerouslySetInnerHTML={ {__html: data.description} }
        >
        </Text>
      </div>

      <div className="set-bd set-bd_disengaged">
        {paddingLevels()}
      </div>
    </div>
  );
}

const saddleShape = PropTypes.shape({
  'name': PropTypes.string,
  'url': PropTypes.string
});

const paddingLevelShape = PropTypes.shape({
  'padding': PropTypes.number,
  'saddles': PropTypes.arrayOf(saddleShape)
});

const dataShape = PropTypes.shape({
  'description': PropTypes.string,
  'name': PropTypes.string,
  'padding_levels': PropTypes.arrayOf(paddingLevelShape).isRequired,
  'size': PropTypes.number,
});

SaddleProductInfo.propTypes = {
  'data': dataShape
};

export default injectIntl(SaddleProductInfo);



// WEBPACK FOOTER //
// ./src/client/pages/product-matches/_saddle-product-info.jsx